module.exports = __webpack_public_path__ + "static/media/title_how_to_playeaabc457c4bca55e6034e1b77b36133b.webp";